const modalIds = {
  continueToAccounts: 'continueToAccountsModal',
  userBookingCustomErrorModal: 'userBookingCustomErrorModal',
  loading: 'loading'
}

export default modalIds
